export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar inspección"])},
          "total": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valor"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la inspección"])},
          "title_container": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Contenedor ", _interpolate(_named("container_code"))])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])}
        }
      }
    }
  })
}